import actionTypes from "../actionTypes";

// ROUTES
import Routes from "../../constants/Routes";

// UTILS
import * as odberatelUtils from "../../utils/odberatel/odberatelUtils";

// ACTIONS
import * as appHeaderActions from "../appHeaderActions";
import * as dodavatelActions from "../dodavatel/dodavatelActions";
import * as spravyActions from "../spravyActions";
import * as zmluvyActions from "../zmluvy/zmluvyActions";

// SUPPORT METHODS
const isStringInURL = (value) => window.location.href.includes(value);
const buildCustomFilters = (field, operator, value) => [
  { field, operator, value },
];

// UPDATE DATA METHODS
const updateZmluvyHeaderAndChangeZmluva = async (dispatch, gridProps) => {
  const action = appHeaderActions.getListZmluvaHeaderAndChangeZmluva;
  await dispatch(action(gridProps));
};
const updateDodavatel = async (dispatch, update) => {
  const action = dodavatelActions.updateDodavatel;
  await dispatch(action(update));
};
const updateCountNeprecSpravy = async (dispatch, I_ORGAN) => {
  const action = spravyActions.getCountNeprecitaneSpravy;
  await dispatch(action(I_ORGAN));
};
const changeZmluva = async (dispatch, zmluva) => {
  const action = zmluvyActions.changeZmluva;
  await dispatch(action({ zmluva }));
};
// IF GRID IS RENDERED - UPDATE GRID DATA AND CUSTOM FILTERS
// ELSE - UPDATE CUSTOM FILTERS
const updateZmluvyGridOrCustomFilters = async (dispatch, gridProps) => {
  const action = isStringInURL(Routes.ZMLUVY)
    ? zmluvyActions.getListZmluva
    : zmluvyActions.updateCustomFiltersZmluvy;

  await dispatch(action(gridProps));
};
const updateSpravyCustomFilters = async (dispatch, customFilters) => {
  const action = spravyActions.updateCustomFiltersSpravy;
  await dispatch(action(customFilters));
};
const updateOdberatelGridOrCustomFilters = async (dispatch, gridProps) => {
  const action = isStringInURL(Routes.ODBERATELIA)
    ? getListOdberatel
    : updateCustomFiltersOdberatel;

  await dispatch(action(gridProps));
};

export const changeOdberatel = (
  { odberatel, grids },
  isPickedByDoubleClickInGridRow = false
) => {
  return async (dispatch) => {
    dispatch({
      type: actionTypes.CHANGE_ODBERATEL,
      data: odberatel,
      isPickedByDoubleClickInGridRow,
    });

    let I_ORGAN = odberatel?.I_ORGAN || -1;
    let customFilters = [];
    let gridProps = {};

    if (odberatel?.I_ORGAN) {
      customFilters = buildCustomFilters("I_ORGAN", "eq", I_ORGAN);

      gridProps = { grids, customFilters };
      await updateZmluvyHeaderAndChangeZmluva(dispatch, gridProps);

      gridProps = { ...grids.zmluvy, customFilters };
      await updateZmluvyGridOrCustomFilters(dispatch, gridProps);
    } else {
      if (odberatel?.NAZOV) {
        customFilters = buildCustomFilters("NAZOV", "contains", odberatel?.NAZOV);
      }
      await changeZmluva(dispatch, { C_ZMLUVY: "", I_ZMLUVY: null });
    }
    gridProps = { ...grids.odberatel, customFilters };
    await updateOdberatelGridOrCustomFilters(dispatch, gridProps);

    await updateCountNeprecSpravy(dispatch, I_ORGAN);
    await updateSpravyCustomFilters(dispatch, customFilters);
    await updateDodavatel(dispatch, I_ORGAN !== -1);
  };
};

const getOdberatelRequest = () => ({
  type: actionTypes.GET_ODBERATEL_REQUEST,
});
const getOdberatelSuccess = (res) => ({
  type: actionTypes.GET_ODBERATEL_SUCCESS,
  res,
});
const getOdberatelFailure = (error) => ({
  type: actionTypes.GET_ODBERATEL_FAILURE,
  error,
});
export const getOdberatel = (id) => {
  return async (dispatch) => {
    try {
      dispatch(getOdberatelRequest());
      let res = await odberatelUtils.getOdberatel(id);
      dispatch(getOdberatelSuccess(res));
    } catch (error) {
      dispatch(getOdberatelFailure(error));
    }
  };
};

export const updateCustomFiltersOdberatel = ({ customFilters }) => {
  return async (dispatch) => {
    dispatch({
      type: actionTypes.UPDATE_CUSTOM_FILTERS_ODBERATEL,
      customFilters,
    });
  };
};
const getListOdberatelRequest = () => ({
  type: actionTypes.GET_LIST_ODBERATEL_REQUEST,
});
const getListOdberatelSuccess = (res, gridFilter, gridSort, gridPage, customFilters) => ({
  type: actionTypes.GET_LIST_ODBERATEL_SUCCESS,
  gridFilter, gridSort, gridPage, customFilters, res
});
const getListOdberatelFailure = (error) => ({
  type: actionTypes.GET_LIST_ODBERATEL_FAILURE,
  error,
});
export const getListOdberatel = ({ gridFilter, gridSort, gridPage, customFilters }) => {
  return async (dispatch) => {
    try {
      dispatch(getListOdberatelRequest());
      const filter = { filters: [...gridFilter.filters, ...customFilters] };
      let res = await odberatelUtils.getListOdberatel(filter, gridSort, gridPage);
      dispatch(getListOdberatelSuccess(res, gridFilter, gridSort, gridPage, customFilters));
    } catch (error) {
      dispatch(getListOdberatelFailure(error));
    }
  };
};

const updateOdberatelRequest = () => ({
  type: actionTypes.UPDATE_ODBERATEL_REQUEST,
});
const updateOdberatelSuccess = (res) => ({
  type: actionTypes.UPDATE_ODBERATEL_SUCCESS,
  res,
});
const updateOdberatelFailure = (error) => ({
  type: actionTypes.UPDATE_ODBERATEL_FAILURE,
  error,
});
export const updateOdberatel = (data) => {
  return async (dispatch) => {
    try {
      dispatch(updateOdberatelRequest());
      let res = await odberatelUtils.updateOdberatel(data);
      dispatch(updateOdberatelSuccess(res));
    } catch (error) {
      dispatch(updateOdberatelFailure(error));
    }
  };
};
